import { Component, OnInit, ViewChild } from '@angular/core';
import { AutocomplateService } from '../../../services/autocomplate.service';
import { Airports } from '../../../models/Airports';
import { SearchParams } from '../../../models/SearchParams';
import { Router } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators
} from '@angular/forms';
import { URLSearchParams } from '@angular/http';
import { checkairportValidator } from './checkairport.validator';
import { checkrangedateValidator } from './checkrangedate.validator';
import { CalendarNames } from '../../../models/CalendarNames';

@Component({
  selector: 'app-homepanel',
  templateUrl: './homepanel.component.html',
  styleUrls: ['./homepanel.component.css'],
  providers: []
})
export class HomepanelComponent implements OnInit {
  selectNumDate = 0;
  showErrors = false;
  searchResult: SearchParams;
  minDateStartDt: Date;
  maxDateStartDt: Date;
  minDateEndDt: Date;
  maxDateEndDt: Date;
  pl: any;
  airport: Airports;
  filteredAirports: Airports[];
  rangeDates: Date[];
  form: FormGroup;

  @ViewChild('airportDep') airportDep;
  @ViewChild('airportArr') aiportArr;
  @ViewChild('rangeDates2') rangeDates2;
  @ViewChild('panelsearchForm') panelsearchForm;
  @ViewChild('startDtCalendar') startDtCalendar;
  @ViewChild('endDtCalendar') endDtCalendar;

  constructor(
    private autocomplateService: AutocomplateService,
    private router: Router,
    private formBuider: FormBuilder
  ) {
    this.searchResult = new SearchParams();
  }

  private buildForm() {
    this.form = this.formBuider.group({
      aiportDep: [
        '',
        { validators: [Validators.required, checkairportValidator] }
      ],
      aiportArr: [
        '',
        { validators: [Validators.required, checkairportValidator] }
      ],
      way: new FormControl('TwoWay', Validators.required),
      multiDay: new FormControl(true),
      startDt: ['', { validators: [Validators.required] }],
      endDt: ['', { validators: [Validators.required] }]
    });
  }

  onSelectStartDt(event) {
    this.minDateEndDt = event;

  //  if (this.form.controls.endDt.value !== '') {
  //    this.form.controls.endDt.setValue(this.form.controls.startDt.value);
      this.form.controls[ 'endDt' ].setValue(event);
   // }
    //  if (this.selectNumDate > 0) {
    //   this.datePicker.overlayVisible = false;
    //   this.selectNumDate = -1;
    //   }
    //   this.selectNumDate++;
  }

  onSelectEndDt(event) {

    this.maxDateStartDt = event;
    //  if (this.selectNumDate > 0) {
    //   this.datePicker.overlayVisible = false;
    //   this.selectNumDate = -1;
    //   }
    //   this.selectNumDate++;
  }

  autocomplateAirports(event) {
    this.autocomplateService.getAitports(event.query).subscribe(countries => {
      this.filteredAirports = countries;
    });
  }

  //  filterAirports( countries: any[]): any[] {
  //
  //    let filtered: any[] = [];
  //
  //    for (let i = 0; i < countries.length; i++) {
  //      let country = countries[i];
  //     filtered.push(country);
  //    }
  //
  //    return filtered;
  //  }

  ngOnInit() {

    this.buildForm();

    this.form.controls.way.valueChanges.subscribe(value => {

      this.form.get('endDt').clearValidators();
      this.form.get('startDt').clearValidators();
      this.form.get('endDt').updateValueAndValidity();
      this.form.get('startDt').updateValueAndValidity();

      if (value === 'TwoWay') {
        this.form.get('endDt').setValidators([Validators.required]);
        this.form.get('endDt').updateValueAndValidity();
      } else {
        this.form.get('startDt').setValidators([Validators.required]);
        this.form.get('startDt').updateValueAndValidity();
      }
    });

    this.pl = CalendarNames.getPLCalendarName();

    this.searchResult.way = 'TwoWay';
    this.searchResult.adult = 1;
    this.searchResult.children = 0;
    //  this.searchResult.aiportDep = new Date();
    this.searchResult.personText = '1 dorosły';

    const today = new Date();
    const month = today.getMonth();
    const year = today.getFullYear();
    const prevMonth = month === 0 ? 11 : month - 1;
    const prevYear = prevMonth === 11 ? year - 1 : year;

    const nextYear = year + 1;
    this.minDateStartDt = new Date();
    this.maxDateStartDt = new Date();
    this.maxDateStartDt.setFullYear(nextYear);

    this.minDateEndDt = new Date();
    this.maxDateEndDt = new Date();
    this.maxDateEndDt.setFullYear(nextYear);
  }

  formatDate(date) {
    const d = new Date(date);
    let  month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }

  onSubmit() {

    this.showErrors = true;

    if (this.panelsearchForm.form.valid) {
      const options = {
        way: this.form.controls.way.value,
        aiportDep: this.form.controls.aiportDep.value.id,
        aiportArr: this.form.controls.aiportArr.value.id,
        aiportDepName: this.form.controls.aiportDep.value.name,
        aiportArrName: this.form.controls.aiportArr.value.name,
        startDt: '',
        endDt: '',
        multiDay: this.searchResult.adult,
        adult: this.searchResult.adult,
        children: this.searchResult.children
      };

      if (this.form.controls.way.value == 'TwoWay') {
        var startDt = new Date(this.form.controls.startDt.value);
        var endDt = new Date(this.form.controls.endDt.value);
        options.startDt = this.formatDate(startDt);
        options.endDt = this.formatDate(endDt);
      } else {
        var startDt = new Date(this.form.controls.startDt.value);
        options.startDt = this.formatDate(startDt);
      }

      this.router.navigate(['/search'], { queryParams: options });
    }
  }

  adultChange(x) {
    this.searchResult.adult = this.searchResult.adult + x;

    if (this.searchResult.adult > 5) {
      this.searchResult.adult = 5;
    }

    if (this.searchResult.adult < 0) {
      this.searchResult.adult = 0;
    }

    this.textPerson();
  }

  childrenChange(x) {
    this.searchResult.children = this.searchResult.children + x;
    if (this.searchResult.children > 5) {
      this.searchResult.children = 5;
    }

    if (this.searchResult.children < 0) {
      this.searchResult.children = 0;
    }

    this.textPerson();
  }

  textPerson() {
    this.searchResult.personText = '';

    if (this.searchResult.adult > 0) {
      if (this.searchResult.adult === 1) {
        this.searchResult.personText = this.searchResult.adult + ' dorosły';
      }
      if (this.searchResult.adult > 1) {
        this.searchResult.personText = this.searchResult.adult + ' dorosłych';
      }
    }

    if (this.searchResult.children > 0) {
      if (this.searchResult.adult > 0) {
        this.searchResult.personText += ', ';
      }

      if (this.searchResult.children === 1) {
        this.searchResult.personText += this.searchResult.children + ' dziecko';
      }

      if (this.searchResult.children > 1) {
        this.searchResult.personText += this.searchResult.children + ' dzieci';
      }
    }
  }
}
